import { Create } from "react-admin";
import { PaymentForm } from "./form";

export const PaymentCreate = () => (
  <Create title="Create payment" redirect="list">
    <PaymentForm source="type" />
  </Create>
);
